export default __webpack_public_path__ + "static/demo-screen-2-c542d76b5b1f72a22899b31c5b1682ae.png";